import * as types from "../actions/geolocation";

const initialState = {
  address: "",
  geolocationError: false,
  userDeniedGeolocation: true,
  userLatitude: null,
  userLongitude: null,
  userSharedLocation: false,
  searchUserLatitude: null,
  searchUserLongitude: null,
  searchUserAddress: "",
};

const geolocation = (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_USER_GEOLOCATION_SUCCESS:
      return { ...state, ...action.payload };
    case types.REQUEST_USER_GEOLOCATION_FAILED:
      return { ...state, ...action.payload };
    case types.USER_GEOLOCATION_COOKIE:
      return { ...state, ...action.payload };
    case types.SET_GEOLOCATION_ADDRESS:
      return { ...state, ...action.payload };
    case types.SET_SEARCHED_LOCATION:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default geolocation;
